import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { apiFetch } from "../Constants/CommonConstant";
import * as Constdata from "../Constants/ApiConstants";
import { resetRefreshTimer } from "./datasSourceRefreshListener";

const fetchAllConfig = async () => {
  // console.log("refresh-fetchAllConfig");
  try {
    const responseJson = await apiFetch(Constdata.GETALLACCOUNT_URL, {
      method: "GET",
      credentials: "include",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json;charset=UTF-8",
      },
    });

    if (responseJson.success !== true) {
      return;
    }

    let value = [];

    if (responseJson.orgInfo.providerName === "AWS") {
      value = responseJson.data.awsConfigs || [];
    } else if (responseJson.orgInfo.providerName === "AZURE") {
      value = responseJson.data.configs || [];
    }

    let isFetching = false;

    value.forEach((key) => {
      let isAnyPriceFetching = false;

      if (responseJson.orgInfo.providerName !== "AWS") {
        const subscriptions = key.azureSubscriptions || [];

        isAnyPriceFetching = subscriptions.some(
          (subscription) =>
            subscription.priceThreadStatus &&
            subscription.priceThreadStatus.toLowerCase().includes("fetching")
        );
      }

      if (
        key.status?.toLowerCase().includes("fetching") ||
        isAnyPriceFetching
      ) {
        isFetching = true;
      }
    });

    // Still fetching
    if (isFetching) {
      resetRefreshTimer();
      console.log("Datasource still fetching. Checking again in 10 seconds...");

      await new Promise((resolve) => {
        setTimeout(resolve, 10000);
      });

      // Call again and WAIT for the final result
      return await fetchAllConfig();
    }
    // Refresh completed
    const isResourceFetching = value.some(
      (val) =>
        val.status?.toLowerCase().includes("fetching") &&
        val.refreshResourceIndex > 0
    );

    if (!isResourceFetching) {
      // console.log("refresh successfully");
      return true;
    }
    return false;
  } catch (error) {
    return false;
  }
};

export const refreshDatasource = createAsyncThunk(
  "datasource/refresh",
  async (_, { rejectWithValue }) => {
    try {
      const response = await apiFetch(
        `${Constdata.STARTALLACCOUNTREFRESH_URL}/2`,
        {
          method: "GET",
          credentials: "include",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json;charset=UTF-8",
          },
        }
      );
      if (!response.success) {
        throw new Error("Datasource refresh API failed");
      }

      console.log('refresh all ds')

      // Wait until GETALLACCOUNT_URL says refresh is completed
      const refresh = await fetchAllConfig();

      if (refresh === true) {
        console.log("Datasource refresh successfully completed");

        return {
          success: true,
          message: "Refresh successfully",
        };
      }
      throw new Error("Datasource refresh was not completed");
    } catch (error) {
      return rejectWithValue(
        error.response?.data || "Datasource refresh failed"
      );
    }
  }
);

const datasourceSlice = createSlice({
  name: "datasource",

  initialState: {
    isRefreshing: false,
    lastRefreshTime: null,
    error: null,
    refreshStatus: "idle",
  },

  reducers: {},

  extraReducers: (builder) => {
    builder
      .addCase(refreshDatasource.pending, (state) => {
        state.isRefreshing = true;
        state.refreshStatus = "pending";
        state.error = null;
      })

      .addCase(refreshDatasource.fulfilled, (state, action) => {
        state.isRefreshing = false;
        state.refreshStatus = "success";
        state.lastRefreshTime = Date.now();
      })

      .addCase(refreshDatasource.rejected, (state, action) => {
        state.isRefreshing = false;
        state.refreshStatus = "failed";
        state.error = action.payload;
      });
  },
});

export default datasourceSlice.reducer;
